import CaretBlueUrl from '@/assets/svg/caret-blue.svg?raw';
import ChevronUrl from '@/assets/svg/chevron.svg?raw';
import { ANIMATION_SPEED_FAST } from '@/settings';
import { svgUriEncoder } from '@/utils';
import { css, unsafeCSS } from 'lit';

export const tomSelectStyles = css`
  .ts-wrapper .ts-control,
  .ts-wrapper .ts-control input,
  .ts-wrapper .ts-dropdown {
    font-size: 1rem;
    line-height: 160%;
    font-family: var(
      --fg-font-family--serif,
      var(--fg-fallback-font-family--serif)
    );
  }

  .ts-wrapper .ts-dropdown {
    max-height: 300px;
    overflow-y: auto;
  }

  .ts-wrapper .ts-dropdown.ts-dropdown.single {
    overflow-y: auto;
  }

  .ts-wrapper .ts-dropdown-content {
    max-height: unset;
  }

  .ts-control {
    min-height: 48px;
    display: flex;
    align-items: center;
    border: 1px solid var(--fg-gray--300, var(--fg-fallback-gray--300));
    position: relative;
    border-radius: var(
      --fg-borderradius--xs,
      var(--fg-fallback-borderradius--xs)
    );
  }

  .ts-wrapper .item,
  .ts-wrapper .option {
    color: var(--fg-text, var(--fg-fallback-text));
    font-weight: 400;
    font-size: 1rem;
  }

  .ts-wrapper .option {
    padding: 8px 16px;
  }

  .ts-wrapper .option:hover,
  .ts-wrapper .option.active {
    background-color: var(--fg-gray--200, var(--fg-fallback-gray--200));
    color: inherit;
  }

  .ts-wrapper .option.selected {
    background-color: var(
      --fg-success--light,
      var(--fg-fallback-success--light)
    );
    border-color: var(--fg-success, var(--fg-fallback-success));
  }

  .ts-control::after {
    content: '';
    background-image: url(${unsafeCSS(svgUriEncoder(CaretBlueUrl))});
    display: block;
    background-repeat: no-repeat;
    width: 11px;
    height: 6px;
    position: absolute;
    right: 16px;
    top: 20px;
    transition: transform ease-in-out ${ANIMATION_SPEED_FAST}s;
  }

  .ts-control[aria-expanded='true']::after {
    transform: rotate(180deg);
  }

  .ts-dropdown.single {
    padding: 10px;
    display: flex;
    gap: 4px;
    border-radius: var(
      --fg-borderradius--xs,
      var(--fg-fallback-borderradius--xs)
    );
    border: none;
    box-shadow: var(--fg-boxshadow, var(--fg-fallback-boxshadow));
    overflow: hidden;
  }

  .ts-dropdown-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .select-container {
    background-color: white;
  }

  .select-container .ts-control,
  .select-container .ts-wrapper.single.input-active .ts-control {
    background: transparent;
    cursor: pointer;
  }

  .select-container .focus .ts-control {
    outline: 2px solid var(--fg-gray--300, var(--fg-fallback-gray--300));
    outline-offset: 2px;
  }

  :host([part='retail']) .ts-control {
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 4px 0px inset;
    border: 1px solid var(--fg-gray--500, var(--fg-fallback-gray--500));
  }

  :host([part='retail']) .ts-control::after {
    mask: url(${unsafeCSS(svgUriEncoder(ChevronUrl))});
    background-color: var(--fg-secondary);
    mask-size: cover;
    -webkit-mask-size: cover;
    height: 15px;
    width: 15px;
    top: 14px;
  }
`;
